module.exports = __webpack_public_path__ + "static/media/Lentes intraoculares BIOMETRO.1d033be7.jpg";